import { Outlet } from "react-router-dom";
import { Box, Container, Divider, Typography } from "@mui/material";
import AuthenticationImage from "../assets/auth/auth-lift.png";
import Logo from "../assets/logo/logo.jpg";
const AuthLayout = () => {
    return (
        <Container maxWidth={false} disableGutters>
            <Box width="100%" sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: "calc(100vh)" }}>
                <Box sx={{ width: '60%', backgroundImage: `url(${AuthenticationImage})`, backgroundRepeat: 'no-repeat', backgroundSize: 'cover', backgroundPosition: 'center', height: '100%' }}>

                </Box>
                <Box sx={{ width: '40%', textAlign: 'center' , display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: '100%' }}>
                    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center', height: '80%'}}>
                        <img src={Logo} alt="Logo" style={{ marginBottom: '20px', maxWidth: '100%', height: 'auto' }} />
                        <Typography variant="h4" color="textPrimary" component="h3">
                            Admin Portal
                        </Typography>
                        <Typography variant="h6" color="textSecondary" component="h2">
                            Welcome Back! Please Login
                        </Typography>
                        <Outlet />
                    </Box>
                    <Box>
                        <Divider sx={{ marginY: 2 }} />
                        <Typography variant="body2" color="textSecondary">
                            &copy; {new Date().getFullYear()} Rainbow Lifts. All rights reserved.
                        </Typography>
                    </Box>
                </Box>
            </Box>
        </Container>
    );
}

export default AuthLayout;